import MUIChip from "@mui/material/Chip";
import MUIStack from "@mui/material/Stack";
import MUITextField from "@mui/material/TextField";
import MUIInputAdornment from "@mui/material/InputAdornment";
import InfoItem from "../InfoItem";
import ReportSetting from "../ReportSetting";

export default class ReportSettingDraggableList extends ReportSetting {
  constructor(props) {
    super(props);
    // Preserve the parent's state.settings and add component-specific state
    this.state = {
      ...this.state,
      items: this.props.grouping,
      deletedItems: [],
      draggingIndex: null,
    };
  }

  componentDidMount() {
    this.checkMissingItems();
  }

  checkMissingItems() {
    const missingItems = this.props.allGroups.filter(
      (item) =>
        !this.state.items.some(
          (existingItem) => existingItem.columnName === item.columnName,
        ),
    );

    if (missingItems.length > 0) {
      const missingItemsToAdd = missingItems.map((item) => ({
        title: item.title,
        columnName: item.columnName,
      }));

      this.setState((prevState) => ({
        deletedItems: [...prevState.deletedItems, ...missingItemsToAdd],
      }));
    }
  }

  handleDragStart(e, index) {
    this.setState({ draggingIndex: index });
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.target);
  }

  handleDragOver = (e) => {
    e.preventDefault();
  };

  handleDrop(e, targetIndex) {
    const { draggingIndex, items } = this.state;
    const updatedItems = [...items];

    const [draggedItem] = updatedItems.splice(draggingIndex, 1);
    updatedItems.splice(targetIndex, 0, draggedItem);

    this.setState(
      {
        items: updatedItems,
        draggingIndex: null,
      },
      () => {
        this.handleSettingChange("grouping", this.state.items);
      },
    );
  }

  handleDeleteChip(index) {
    const updatedItems = [...this.state.items];
    const deletedChip = updatedItems.splice(index, 1)[0];
    this.setState(
      (prevState) => ({
        items: updatedItems,
        deletedItems: [...prevState.deletedItems, deletedChip],
      }),
      () => {
        this.handleSettingChange("grouping", this.state.items);
      },
    );
  }

  handleReAddChip = (index) => {
    const updatedDeletedItems = [...this.state.deletedItems];
    const chipToReAdd = updatedDeletedItems.splice(index, 1)[0];
    this.setState(
      (prevState) => ({
        deletedItems: updatedDeletedItems,
        items: [...prevState.items, chipToReAdd],
      }),
      () => {
        this.handleSettingChange("grouping", this.state.items);
      },
    );
  };

  /** Drag and drop active grouping chips */
  renderActiveGrouping() {
    return (
      <MUITextField
        value={this.props.accountType ? this.props.accountType.name : ""}
        size="small"
        label="Active Grouping"
        variant="standard"
        fullWidth
        helperText={
          this.state.items.length > 0
            ? "Drag and drop chips to reorder the grouping"
            : ""
        }
        slotProps={{
          input: {
            startAdornment: (
              <MUIInputAdornment position="start">
                <div style={{ display: "flex", marginTop: 8 }}>
                  {this.state.items.map((item, index) => (
                    <MUIChip
                      key={index}
                      draggable
                      onDragStart={(e) => this.handleDragStart(e, index)}
                      onDragOver={this.handleDragOver}
                      onDrop={(e) => this.handleDrop(e, index)}
                      label={item.title}
                      clickable
                      onDelete={() => this.handleDeleteChip(index)}
                      sx={{ mr: 1, mb: 1 }}
                      color="primary"
                    />
                  ))}
                </div>
              </MUIInputAdornment>
            ),
            sx: {
              paddingBottom: 1,
              paddingTop: 1,
            },
          },

          inputLabel: { shrink: true },
        }}
      />
    );
  }
  /** Remove grouping chips */
  renderRemoveGroupingChips() {
    return (
      <MUITextField
        value={this.props.accountType ? this.props.accountType.name : ""}
        size="small"
        label="Removed Grouping"
        variant="standard"
        fullWidth
        helperText={
          this.state.deletedItems.length > 0
            ? "Click a chip to restore it to the active grouping"
            : ""
        }
        slotProps={{
          input: {
            startAdornment: (
              <MUIInputAdornment position="start">
                <div style={{ display: "flex", marginTop: 8 }}>
                  {this.state.deletedItems.map((item, index) => (
                    <MUIChip
                      key={index}
                      label={item.title}
                      clickable
                      onClick={() => this.handleReAddChip(index)}
                      sx={{ mr: 1, mb: 1 }}
                    />
                  ))}
                </div>
              </MUIInputAdornment>
            ),
            sx: {
              paddingBottom: 1,
              paddingTop: 1,
            },
          },

          inputLabel: { shrink: true },
        }}
      />
    );
  }

  renderContent() {
    return (
      <MUIStack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
        }}
      >
        {this.renderActiveGrouping()}
        {this.renderRemoveGroupingChips()}
      </MUIStack>
    );
  }

  renderReadOnly() {
    const { items } = this.state;

    if (!items || items.length === 0) {
      return <InfoItem label="Grouping" value="None" />;
    }

    const groupingText = items.map((item) => item.title).join(", ");
    return <InfoItem label="Grouping" value={groupingText} />;
  }
}
